// graphql/oattcomputation.gql.ts

import { gql } from '@apollo/client';

// ── Shared fragment ──────────────────────────────────────────────────────────
export const OATT_COMPUTED_FRAGMENT = gql`
  fragment OattComputedFields on OattComputedRecord {
    oatt_computed_id
    raw_id
    seller
    aref
    customer_code
    billing_period
    billing_type
    mw_granted
    billing_rate
    hours

    start_time
    stop_time
    duration_value
    duration_unit
    peak
    dow
    on_peak_hours
    off_peak_hours

    firm_transmission_charge_oatt
    nonfirm_transmission_charge_oatt
    ancillary_schedule1_oatt
    ancillary_schedule2_oatt
    total_charges_oatt

    firm_transmission_rate
    nonfirm_transmission_rate
    ancillary_schedule1_rate
    ancillary_schedule2_rate

    firm_transmission_charge_computed
    nonfirm_transmission_charge_computed
    ancillary_schedule1_computed
    ancillary_schedule2_computed
    total_charges_computed

    adjustments
    validated_status
    oatt_data_source_selected
    is_revision
    revision_no
  }
`;

// ── Query ────────────────────────────────────────────────────────────────────
export const GET_OATT_COMPUTED = gql`
  ${OATT_COMPUTED_FRAGMENT}
  query GetOattComputed($month: Int!, $year: Int!, $customerId: Int) {
    getOattComputed(month: $month, year: $year, customerId: $customerId) {
      ...OattComputedFields
    }
  }
`;

// ── Mutation ─────────────────────────────────────────────────────────────────
export const COMPUTE_OATT_DATA = gql`
  ${OATT_COMPUTED_FRAGMENT}
  mutation ComputeOattData($month: Int!, $year: Int!, $customerId: Int) {
    computeOattData(month: $month, year: $year, customerId: $customerId) {
      success
      message
      count
      records {
        ...OattComputedFields
      }
    }
  }
`;

export const COMPUTE_OATT_REVISION = gql`
  mutation ComputeOattRevision($month: Int!, $year: Int!, $revisionNo: Int!) {
    computeOattRevision(month: $month, year: $year, revisionNo: $revisionNo) {
      success
      message
      count
    }
  }
`;